import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import menu from './images/bars-solid.svg'
import './nav.css'
import logo from './images/perkleaflogo.png'

function NewNav() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div style={{overflow:'hidden'}} id='impo'>
        <Button id='canvasBtn'
          variant="primary" onClick={handleShow}>
          <img style={{overflow:'hidden'}} src={menu} />
        </Button>

        <Offcanvas style={{overflow:'hidden'}} show={show} onHide={handleClose}>
          <Offcanvas.Header style={{overflow:'hidden'}} closeButton>
            <Offcanvas.Title>
              <img style={{ width: "90px", height: "90px",overflow:"hidden",margin:"10px" }} src={logo} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <p><a id='aMenu' href='/'>Home</a></p>
            {/* <p><a id='aMenu' href='about'>About us</a></p> */}
            <p><a id='aMenu' href='product'>Product</a></p>
            <p><a id='aMenu' href='contact'>Contact</a></p>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
}

export default NewNav;